// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.loading-indicator {
  padding: 0;
  display: none;
}
.loading-indicator--big {
  width: 64px;
  height: 64px;
  border: 4px solid var(--color-accent-background-base);
}
.loading-indicator--medium {
  width: 32px;
  height: 32px;
  border: 2px solid var(--color-accent-background-base);
}
.loading-indicator--medium,
.loading-indicator--big {
  border-bottom-color: transparent;
  border-radius: 50%;
  box-sizing: border-box;
  animation: loading-indicator-rotation 1s linear infinite;
}
.loading-indicator--medium.loading-indicator--custom-color,
.loading-indicator--big.loading-indicator--custom-color {
  border-top-color: currentColor;
  border-left-color: currentColor;
  border-right-color: currentColor;
}
.loading-indicator--small {
  width: 20px;
  height: 20px;
}
.loading-indicator--xsmall {
  width: 16px;
  height: 16px;
}
.loading-indicator--small,
.loading-indicator--xsmall {
  animation: loading-indicator-rotation 1s infinite linear;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  color: var(--color-content-base);
}
.loading-indicator--small.loading-indicator--custom-color,
.loading-indicator--xsmall.loading-indicator--custom-color {
  color: currentColor;
}
.loading-indicator--visible {
  display: block;
}
.loading-indicator--centered {
  position: absolute;
  top: calc(50% - 32px);
  left: calc(50% - 32px);
}
.loading-indicator--centered.loading-indicator--small {
  position: absolute;
  top: calc(50% - 10px);
  left: calc(50% - 10px);
}
.loading-indicator--centered.loading-indicator--medium {
  position: absolute;
  top: calc(50% - 16px);
  left: calc(50% - 16px);
}
@keyframes loading-indicator-rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/components/loading-indicator/LoadingIndicator.less","webpack://./src/neptune-app/components/mixins.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AANA;EACE,UAAA;EACA,aAAA;AAQF;AANE;EACE,WAAA;EACA,YAAA;EACA,qDAAA;AAQJ;AALE;EACE,WAAA;EACA,YAAA;EACA,qDAAA;AAOJ;AAJE;;EACE,gCAAA;EACA,kBAAA;EACA,sBAAA;EACA,wDAAA;AAOJ;AAJE;;EACE,8BAAA;EACA,+BAAA;EACA,gCAAA;AAOJ;AAJE;EACE,WAAA;EACA,YAAA;AAMJ;AAHE;EACE,WAAA;EACA,YAAA;AAKJ;AAFE;;EACE,wDAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;AAKJ;AAFE;;EACE,mBAAA;AAKJ;AAFE;EACE,cAAA;AAIJ;AADE;ECtDA,kBAAA;EACA,qBAAA;EACA,sBAAA;AD0DF;AAFE;EC1DA,kBAAA;EACA,qBAAA;EACA,sBAAA;AD+DF;AAHE;EC9DA,kBAAA;EACA,qBAAA;EACA,sBAAA;ADoEF;AAJE;EACE;IACE,uBAAA;EAMJ;EAJE;IACE,yBAAA;EAMJ;AACF","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~components/variables';\n@import '~components/mixins';\n\n.loading-indicator {\n  padding: 0;\n  display: none;\n\n  &--big {\n    width: @loading-spinner-size;\n    height: @loading-spinner-size;\n    border: 4px solid var(--color-accent-background-base);\n  }\n\n  &--medium {\n    width: @medium-loading-spinner-size;\n    height: @medium-loading-spinner-size;\n    border: 2px solid var(--color-accent-background-base);\n  }\n\n  &--medium, &--big {\n    border-bottom-color: transparent;\n    border-radius: 50%;\n    box-sizing: border-box;\n    animation: loading-indicator-rotation 1s linear infinite;\n  }\n\n  &--medium&--custom-color, &--big&--custom-color {\n    border-top-color: currentColor;\n    border-left-color: currentColor;\n    border-right-color: currentColor;\n  }\n\n  &--small {\n    width: @small-loading-spinner-size;\n    height: @small-loading-spinner-size;\n  }\n\n  &--xsmall {\n    width: @xsmall-loading-spinner-size;\n    height: @xsmall-loading-spinner-size;\n  }\n\n  &--small, &--xsmall {\n    animation: loading-indicator-rotation 1s infinite linear;\n    border-radius: 50%;\n    width: @xsmall-loading-spinner-size;\n    height: @xsmall-loading-spinner-size;\n    color: var(--color-content-base);\n  }\n\n  &--small&--custom-color, &--xsmall&--custom-color {\n    color: currentColor;\n  }\n\n  &--visible {\n    display: block;\n  }\n\n  &--centered {\n    .centered-loading();\n  }\n\n  &--centered&--small {\n    .centered-loading(@small-loading-spinner-size);\n  }\n\n  &--centered&--medium {\n    .centered-loading(@medium-loading-spinner-size);\n  }\n\n  @keyframes loading-indicator-rotation {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n}\n","@import './variables';\n\n.centered-loading(@size: @loading-spinner-size) {\n  @loading-spinner-offset: (@size / 2);\n  position: absolute;\n  top: ~\"calc(50% - @{loading-spinner-offset})\";\n  left: ~\"calc(50% - @{loading-spinner-offset})\";\n}\n\n.summary-section-subtitle() {\n  font-size: @fontSize-sm;\n  line-height: 22px;\n  color: var(--color-content-base);\n  font-weight: @fontWeight-semibold;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
